import React, { useRef } from "react";
import "date-fns";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import IconButton from "@material-ui/core/IconButton";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import { useEffect, useState } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import Divider from "@material-ui/core/Divider";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import FormControl from "@material-ui/core/FormControl";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import EditIconRounded from "@material-ui/icons/EditRounded";
import DeleteOtlined from "@material-ui/icons/DeleteRounded";
import { useContext } from "react";
import axios from "axios";
import { AuthContext } from "../../../context/AuthContex";
import { CircularProgress } from "@material-ui/core";

import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import { blueGrey } from "@material-ui/core/colors";
import { green } from "@material-ui/core/colors";

import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const ModaluseStyles = makeStyles((theme) => ({
  form: {
    display: "flex",
    flexDirection: "column",
  },
  formControl: {
    marginTop: theme.spacing(2),
    minWidth: 180,
  },
  formControlLabel: {
    marginTop: theme.spacing(1),
  },
}));

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const rows = [];

const useStyles = makeStyles({
  table: {
    minWidth: 700,
  },
});

const useBtnStyles = makeStyles((theme) => ({
  margin: {
    margin: theme.spacing(1),
  },
  extendedIcon: {
    marginRight: theme.spacing(1),
  },
}));

export default function TabelaQuote() {
  const PF = process.env.REACT_APP_PUBLIC_FOLDER;
  const { user } = useContext(AuthContext);

  const [tableRows, settableRows] = useState([]);
  const [deleteSuccess, setdeleteSuccess] = useState("");
  const [quotes, setquotes] = useState([]);
  const [savingQuote, setsavingQuote] = useState(false);
  const [tableinformation, settableinformation] = useState([]);
  const [editQuote, seteditQuote] = useState(false);
  const [condicaoPreco, setCondicaoPreco] = React.useState("");
  const [condicaoTempora, setcondicaoTempora] = React.useState("");
  const [openSuccess, setOpenSuccess] = useState(false);
  const [dialogMessage, setdialogMessage] = useState({
    message: "Guardado Com Successo",
    style: "success",
  });

  const handlecondicaoPreco = (event) => {
    setCondicaoPreco(event.target.value);
  };
  const handlecondicaoTemporal = (event) => {
    setcondicaoTempora(event.target.value);
  };

  const classes = useStyles();
  const classButton = useBtnStyles();

  const modelClass = ModaluseStyles();

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    settableinformation([]);
    seteditQuote(false);
    setOpen(true);
  };

  const handleClickOpenEdit = (row) => {
    settableinformation(row);
    seteditQuote(true);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const codigo_de_negociacao = useRef();
  const quantidade_compra = useRef();
  const preco_compra = useRef();
  const quantidade_venda = useRef();
  const preco_venda = useRef();
  const comentario = useRef();

  const criarQuote = async () => {
    setsavingQuote(true);
    setdialogMessage({ message: "Efectuado com succeso", style: "info" });
    const quote = {
      id_cliente: user._id,
      codigo_de_negociacao: codigo_de_negociacao.current.value,
      quantidade_compra: quantidade_compra.current.value
        ? quantidade_compra.current.value
        : "-",
      preco_compra: preco_compra.current.value
        ? preco_compra.current.value
        : "-",
      quantidade_venda: quantidade_venda.current.value
        ? quantidade_venda.current.value
        : "-",
      preco_venda: preco_venda.current.value ? preco_venda.current.value : "-",
      comentario: comentario.current.value ? comentario.current.value : "-",
    };

    try {
      await axios.post("quote/novo", quote);
      setsavingQuote(false);
      setquotes(quote);
      setOpen(false);
      setOpenSuccess(true);
    } catch (err) {
      console.log(err);
    }
  };

  const DeleteQuote = async (id) => {
    setdialogMessage({ message: "Eliminado com Successo", style: "warning" });
    try {
      setdeleteSuccess([]);
      const res = await axios.delete("quote/" + id);
      setdeleteSuccess(res.data);
      setOpen(false);
      setOpenSuccess(true);
    } catch (err) {
      console.log(err);
    }
  };

  const guardarQuotes = async (id) => {
    setdialogMessage({ message: "Guardado Com Successo", style: "success" });

    setsavingQuote(true);
    const quote = {
      id_cliente: user._id,
      codigo_de_negociacao: codigo_de_negociacao.current.value,
      quantidade_compra: quantidade_compra.current.value
        ? quantidade_compra.current.value
        : "-",
      preco_compra: preco_compra.current.value
        ? preco_compra.current.value
        : "-",
      quantidade_venda: quantidade_venda.current.value
        ? quantidade_venda.current.value
        : "-",
      preco_venda: preco_venda.current.value ? preco_venda.current.value : "-",
      comentario: comentario.current.value ? comentario.current.value : "-",
    };
    try {
      const res = await axios.put("quote/" + id, quote);
      setsavingQuote(false);
      setquotes(quote);
      setOpen(false);
      setOpenSuccess(true);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    const buscarQuote = async () => {
      try {
        const res = await axios.get("quote/usuario/" + user._id);
        settableRows(res.data);
      } catch (err) {
        console.log(err);
      }
    };
    buscarQuote();
  }, [quotes, deleteSuccess]);

  const [selectedDate, setSelectedDate] = React.useState(
    new Date("2014-08-18T21:11:54")
  );

  const handleCloseSuccess = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenSuccess(false);
  };

  return (
    <>
      <IconButton aria-label="accao" onClick={handleClickOpen}>
        <AddCircleOutlineIcon />
      </IconButton>
      Nova Quota
      <TableContainer component={Paper}>
        <Table className={classes.table} aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell>Código de Negociação </StyledTableCell>
              <StyledTableCell align="right">
                Quantidade(Compra)
              </StyledTableCell>
              <StyledTableCell align="right">Preço(Compra)</StyledTableCell>
              <StyledTableCell align="right">Quantidade(Venda)</StyledTableCell>
              <StyledTableCell align="right">Preço(Venda)</StyledTableCell>
              <StyledTableCell align="right">Estado</StyledTableCell>
              <StyledTableCell align="right">Alterar</StyledTableCell>
              <StyledTableCell align="right">Eliminar</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {tableRows.map((row) => (
              <StyledTableRow key={row._id}>
                <StyledTableCell component="th" scope="row">
                  {row.codigo_de_negociacao}
                </StyledTableCell>
                <StyledTableCell align="right">
                  {row.quantidade_compra}
                </StyledTableCell>
                <StyledTableCell align="right">
                  {row.preco_compra}
                </StyledTableCell>
                <StyledTableCell align="right">
                  {row.quantidade_venda}
                </StyledTableCell>
                <StyledTableCell align="right">
                  {row.preco_venda}
                </StyledTableCell>

                <StyledTableCell align="right">Pendente</StyledTableCell>
                <StyledTableCell align="right">
                  <IconButton
                    aria-label="accao"
                    onClick={() => handleClickOpenEdit(row)}
                    className={classButton.margin}
                  >
                    <EditIconRounded />
                  </IconButton>
                </StyledTableCell>

                <StyledTableCell align="right">
                  <IconButton
                    aria-label="accao"
                    className={classButton.margin}
                    onClick={() => DeleteQuote(row._id)}
                  >
                    <DeleteOtlined style={{ color: "#b2102f" }} />
                  </IconButton>
                </StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Snackbar
        open={openSuccess}
        autoHideDuration={2300}
        onClose={handleCloseSuccess}
      >
        <Alert onClose={handleCloseSuccess} severity={dialogMessage.style}>
          {dialogMessage.message}
        </Alert>
      </Snackbar>
      <Dialog
        fullWidth={true}
        maxWidth={"md"}
        open={open}
        onClose={handleClose}
        aria-labelledby="max-width-dialog-title"
      >
        <DialogTitle id="max-width-dialog-title">Criar Nova Quote</DialogTitle>
        <DialogContent>
          <DialogContentText>inserção de uma Quote</DialogContentText>
          <form className={modelClass.form} noValidate>
            <Grid container spacing={3} style={{ marginTop: "10px" }}>
              <Grid item xs={4}>
                <FormControl className={modelClass.formControl}>
                  <TextField
                    id="filled-read-only-input"
                    label="Codigo de negociacao "
                    defaultValue={tableinformation.codigo_de_negociacao}
                    inputRef={codigo_de_negociacao}
                    variant="filled"
                  />
                </FormControl>
              </Grid>
              <Grid item xs={4}>
                <FormControl className={modelClass.formControl}>
                  <TextField
                    id="filled-read-only-input"
                    label="Quantidade De Compra"
                    defaultValue={tableinformation.quantidade_compra}
                    inputRef={quantidade_compra}
                    variant="filled"
                    type="number"
                  />
                </FormControl>
              </Grid>

              <Grid item xs={4}>
                <FormControl className={modelClass.formControl}>
                  <TextField
                    id="filled-read-only-input"
                    label="Preço De Compra"
                    defaultValue={tableinformation.preco_compra}
                    inputRef={preco_compra}
                    variant="filled"
                    type="number"
                  />
                </FormControl>
              </Grid>

              <Grid item xs={4}>
                <FormControl className={modelClass.formControl}>
                  <TextField
                    id="filled-read-only-input"
                    label="Quantidade de Venda"
                    defaultValue={tableinformation.quantidade_venda}
                    inputRef={quantidade_venda}
                    variant="filled"
                    type="number"
                  />
                </FormControl>
              </Grid>
              <Grid item xs={4}>
                <FormControl className={modelClass.formControl}>
                  <TextField
                    id="filled-read-only-input"
                    label="Preço de Compra"
                    defaultValue={tableinformation.preco_venda}
                    inputRef={preco_venda}
                    variant="filled"
                    type="number"
                  />
                </FormControl>
              </Grid>

              <Grid item xs={4}>
                <FormControl className={modelClass.formControl}>
                  <TextField
                    id="filled-read-only-input"
                    label="Comentário"
                    defaultValue={tableinformation.comentario}
                    inputRef={comentario}
                    variant="filled"
                  />
                </FormControl>
              </Grid>

              {!editQuote ? (
                <Grid item xs={4}>
                  <Button
                    variant="contained"
                    onClick={criarQuote}
                    color="primary"
                    disabled={savingQuote}
                  >
                    {!savingQuote ? (
                      "Efectuar"
                    ) : (
                      <CircularProgress color="green" size="22px" />
                    )}
                  </Button>
                </Grid>
              ) : (
                <>
                  <Grid item xs={4} style={{ marginTop: "20px" }}></Grid>
                  <Grid item xs={2} style={{ marginTop: "20px" }}>
                    <Button
                      variant="contained"
                      onClick={() => guardarQuotes(tableinformation._id)}
                      color="primary"
                      disabled={savingQuote}
                    >
                      {!savingQuote ? (
                        "Guardar"
                      ) : (
                        <CircularProgress color="green" size="22px" />
                      )}
                    </Button>
                  </Grid>

                  <Grid item xs={2} style={{ marginTop: "20px" }}>
                    <Button
                      variant="contained"
                      color="secondary"
                      disabled={savingQuote}
                      onClick={() => DeleteQuote(tableinformation._id)}
                    >
                      {!savingQuote ? (
                        "Eliminar"
                      ) : (
                        <CircularProgress color="green" size="22px" />
                      )}
                    </Button>
                  </Grid>
                </>
              )}
            </Grid>
          </form>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Fechar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
